import { render, staticRenderFns } from "./BatchInput.vue?vue&type=template&id=53b5d40d&scoped=true&"
import script from "./BatchInput.vue?vue&type=script&lang=js&"
export * from "./BatchInput.vue?vue&type=script&lang=js&"
import style0 from "./BatchInput.vue?vue&type=style&index=0&id=53b5d40d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5d40d",
  null
  
)

export default component.exports